import { useEffect } from "react";

// One tab per financial year, oldest to newest (like workbook sheets). Selects the current FY by default.
export default function FyTabs({ fys, value, onChange, prefix }) {
  const sorted = [...(fys || [])].sort((a, b) => a.start_year - b.start_year);
  useEffect(() => {
    if (!value && sorted.length) onChange((sorted.find((f) => f.is_current) || sorted[sorted.length - 1]).label);
  }, [value, sorted, onChange]);
  return (
    <div className="flex flex-wrap gap-1 border border-border bg-card p-1 w-fit rounded-full" data-testid={`${prefix}-fy-tabs`}>
      {sorted.map((f) => (
        <button key={f.id} type="button" onClick={() => onChange(f.label)} data-testid={`${prefix}-fy-tab-${f.label}`}
          className={`px-4 py-1.5 text-sm font-mono rounded-full transition-colors duration-150 ${
            value === f.label ? "bg-primary/10 text-primary font-semibold" : "text-muted-foreground hover:text-foreground hover:bg-accent/60"
          }`}>
          {f.label}{f.is_current && <span className="ml-1.5 inline-block h-1.5 w-1.5 rounded-full bg-emerald-400 align-middle" />}
        </button>
      ))}
    </div>
  );
}
